import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import { formatName } from '@/app/utils/formatName'
import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'
import { ReportCustomers } from '@/app/services/reportService/reportCustomers'
import masks from '@/app/utils/masks'

const columnHelper = createColumnHelper<ReportCustomers>()

const columns = [
  columnHelper.accessor('name', {
    id: 'name',
    header: () => (
      <div className="flex w-full flex-col items-start gap-1 pl-2">
        <div className="block">Nome</div>
        <div className="block text-sm text-gray-400 2xl:hidden">Email</div>
        <div className="block text-sm text-gray-400 xl:hidden">CPF</div>
        <div className="block text-sm text-gray-400 lg:hidden">Telefone</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col items-start gap-1 pl-4">
        <div>
          <p>{formatName(row.original.name)}</p>
        </div>
        <div className="block text-sm text-gray-400 2xl:hidden">
          {row.original.email}
        </div>
        <div className="block text-sm text-gray-400 xl:hidden">
          {masks.cpf(row.original.cpf)}
        </div>
        <div className="block text-sm text-gray-400 lg:hidden">
          {masks.phone(row.original.phone)}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('email', {
    id: 'email',
    header: () => <div className="hidden text-left 2xl:block">Email</div>,
    cell: ({ row }) => (
      <div className="hidden text-left 2xl:block">{row.original.email}</div>
    ),
  }),
  columnHelper.accessor('cpf', {
    id: 'cpf',
    header: () => <div className="hidden text-center xl:block">CPF</div>,
    cell: ({ row }) => (
      <div className="hidden text-center xl:block">
        {masks.cpf(row.original.cpf)}
      </div>
    ),
  }),
  columnHelper.accessor('phone', {
    id: 'phone',
    header: () => <div className="hidden text-center lg:block">Telefone</div>,
    cell: ({ row }) => (
      <div className="hidden text-center lg:block">
        {masks.phone(row.original.phone)}
      </div>
    ),
  }),
  columnHelper.accessor('available.amount', {
    id: 'amount',
    header: () => (
      <div className="hidden text-center xl:block">
        <div>Saldo</div>
      </div>
    ),
    cell: ({ row }) => {
      return (
        <div className="hidden xl:block">
          <div className="flex flex-col items-center justify-center">
            {row.original.available.isAutorized ? (
              <span className="flex items-baseline gap-2">
                <i className="fa-solid fa-circle-check text-sm text-success" />
                {formatMoneyValue(row.original.available.amount)}
              </span>
            ) : (
              <span className="flex items-baseline gap-2">
                <i className="fa-solid fa-circle-exclamation text-error" />
                {' -'}
              </span>
            )}
          </div>
        </div>
      )
    },
  }),
  columnHelper.accessor('transactions', {
    id: 'transactions',
    header: () => (
      <div className="text-center">
        <div>Transações</div>
        <div className="block text-sm text-gray-400 2xl:hidden">
          Transações (R$)
        </div>
        <div className="block text-sm text-gray-400 xl:hidden">Saldo</div>
        <div className="block text-sm text-gray-400 lg:hidden">
          Ultima transação
        </div>
      </div>
    ),
    cell: ({ row }) => {
      const lastTransaction = row.original.lastTransaction
      return (
        <div className="flex flex-col items-center justify-center">
          <div>{row.original.transactions}</div>
          <div className="block text-sm text-gray-400 2xl:hidden">
            {formatMoneyValue(row.original.total)}
          </div>
          <div className="block text-sm text-gray-400 xl:hidden">
            <div className="flex flex-col items-center justify-center">
              {row.original.available.isAutorized ? (
                <span className="flex items-baseline gap-2">
                  <i className="fa-solid fa-circle-check text-sm text-success" />
                  {formatMoneyValue(row.original.available.amount)}
                </span>
              ) : (
                <span className="flex items-baseline gap-2">
                  <i className="fa-solid fa-circle-exclamation text-error" />
                  {' -'}
                </span>
              )}
            </div>
          </div>
          <div className="block text-sm text-gray-400 lg:hidden">
            {lastTransaction
              ? format(lastTransaction, 'dd/MM/yyyy, HH:mm')
              : 'Sem Transações'}
          </div>
        </div>
      )
    },
  }),
  columnHelper.accessor('total', {
    id: 'total',
    header: () => (
      <div className="hidden text-center 2xl:block">
        <div>Transações (R$)</div>
      </div>
    ),
    cell: ({ row }) => {
      return (
        <div className="hidden text-center 2xl:block">
          {formatMoneyValue(row.original.total)}
        </div>
      )
    },
  }),
  columnHelper.accessor('lastTransaction', {
    id: 'data',
    header: () => (
      <div className="hidden pr-2 text-right lg:block">Ultima Transação</div>
    ),
    cell: ({ row }) => {
      const lastTransaction = row.original.lastTransaction
      return (
        <div className="hidden pr-4 text-right lg:block">
          {lastTransaction
            ? format(lastTransaction, 'dd/MM/yyyy, HH:mm')
            : 'Sem Transações'}
        </div>
      )
    },
  }),
]

export const TableReportCustomersColumnsDefinition = () => {
  return {
    columns,
  }
}
